
import { useState } from 'react';
import Status  from 'components/global/Status'
import EyetSVG from 'assets/svgs/EyetSVG';
import TrashSvg from 'assets/svgs/TrashSvg';
import SearchBox from 'components/global/SearchBox';

import img from "assets/images/img2.jpg";
import { useSelector } from 'react-redux';
import { baseURL } from 'config/api';
import moment from "moment";
import {customer_delete}  from 'redux/actions/customerActions';
  import { useQueryClient } from 'react-query';
import confirmBox from "utils/confirmBox";
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Loader from 'components/global/Loader';
import DisplayError from 'components/global/DisplayError';
import ItemNotFound from 'components/global/ItemNotFound';


// import EditTSvg from 'assets/svgs/EditTSvg';
// import CheckAllSVG   from 'assets/svgs/CheckAll';
// import ArrowDownSvg from "assets/svgs/ArrowDownSvg";


const Hometable = ({ keyword, setKeyword,isLoading,isError }) => {
   const { docs } = useSelector(state => state.customer);
    const {user } = useSelector((state) => state.auth);
  const dispatch=useDispatch();
const navigate=useNavigate();
  const queryClient = useQueryClient();

  


  function formatLabel(text = "") {
  return text
    .replace(/_/g, " ")       
    .split(" ")               
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");           
}

const handleDelete = async (ID) => {


   if (!user?.isSuperAdmin) {
    toast.error("You are not authorized to delete this Customer.");
    return;
  }
  const title = 'Confirm Deletion';
  const message = 'Are you sure you want to delete this Customer?';

  const onYesClick = async () => {
    await dispatch(customer_delete(ID));
    queryClient.invalidateQueries(["fetch-all-customer"]);
  };

  confirmBox({ title, message, onYesClick });
};






  return (
    <div className="w-full table-container  bg-white flex flex-col gap-2 pb-4">

<div className=' flex flex-col  sm:flex-row sm:justify-between  w-full px-3'>
  <p className="text-dark1 font-semibold">Recent Customers</p>  
  <div className=' w-full sm:w-[267px]'>
<SearchBox

    keyword={keyword}
          setKeyword={setKeyword}
/>
  </div>
   
</div>




{
  isLoading ? (
    <Loader />
  ) : isError ? (
    <DisplayError message={isError} />
  ) : docs?.length === 0 ? (
    <ItemNotFound  message="No Recent Customer found."/>
  ) : (
    <div className="overflow-x-auto maintable">
      <table className="w-full bg-white">
        <thead className="text-left text-sm md:text-[15px]">
          <tr>
            <th className="px-3 py-4 whitespace-nowrap">No</th>
            <th className="px-3 py-4 whitespace-nowrap">ID Code</th>
            <th className="px-3 py-4 whitespace-nowrap">Customer Name</th>
            <th className="px-3 py-4 whitespace-nowrap">Phone Number</th>
            <th className="px-3 py-4 whitespace-nowrap">Created Date</th>
            <th className="px-3 py-4 whitespace-nowrap">Location</th>
            {/* <th className="px-3 py-4 whitespace-nowrap">Status</th> */}
            <th className="px-3 py-4 whitespace-nowrap">Action</th>
          </tr>
        </thead>

        <tbody>
          {docs.map((row) => (
            <tr key={row?._id}>
              <td className="px-3 py-4 whitespace-nowrap">{row?.autoIncrementId}</td>

              <td className="px-3 py-4 whitespace-nowrap">{row?.longAutoIncrementId}</td>

              <td className="px-3 py-4 whitespace-nowrap">
                <div className="flex items-center gap-2">
                  <div className="w-[32px] h-[32px] overflow-hidden rounded-full">
                    <img
                      src={row?.image ? `${baseURL}/${row?.image}` : img}
                      alt="user avatar"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  {row?.name}
                </div>
              </td>

              <td className="px-3 py-4 whitespace-nowrap">{row?.phoneNumber ?? ""}</td>

              <td className="px-3 py-4 whitespace-nowrap">
                {row?.createdAt ? moment(row?.createdAt).format("DD-MM-YYYY") : "-"}
              </td>

              <td className="px-3 py-4 whitespace-nowrap">
                {row?.countryName && (
                  <div className="w-fit px-3 rounded-md py-1 bg-[#EDF1F3]">
                    {row?.countryName}
                  </div>
                )}
              </td>

              {/* <td className="px-3 py-4 whitespace-nowrap">
                <Status
                  status={
                    row?.status === "assigned"
                      ? "Assigned"
                      : row?.status === "not_assigned"
                      ? "Not Assigned"
                      : row?.status === "deleted"
                      ? "Deleted"
                      : "Unknown"
                  }
                />
              </td> */}

              <td className="px-3 py-4 whitespace-nowrap">
                {row?.status === "deleted" ? (
                  <></>
                ) : (
                  <div className="flex flex-row gap-1.5 items-center">

                    {/* View */}
                    <div
                      onClick={() => navigate(`/app/Customer-detail/${row._id}`)}
                      className="w-fit px-2.5 py-2.5 rounded-lg bg-primary cursor-pointer"
                    >
                      <EyetSVG />
                    </div>

                    {user?.isSuperAdmin && (
                      <div
                        onClick={() => handleDelete(row?._id)}
                        className="w-fit px-2.5 py-2.5 rounded-lg bg-darkred cursor-pointer"
                      >
                        <TrashSvg />
                      </div>
                    )}
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}  

     




       


   





      
    </div>
  );
};

export default Hometable;


      